import React from "react";

function IconPiano() {
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" viewBox="0 0 256 256" enableBackground="new 0 0 256 256">
<g><g><g><path fill="#000000" d="M10,128v87.3h118h118V128V40.7H128H10V128z M30.9,92v40.9h4.9h4.9v36v36H30.6H20.4V128V51.2h5.2h5.2V92L30.9,92z M71.5,92v40.9h5.2h5.2v36v36H66.5H51.2v-36v-36h4.9H61V92V51.2h5.2h5.2V92L71.5,92z M123.1,128v76.8h-15.7H91.7v-36v-36H97h5.2V92V51.2h10.5h10.4L123.1,128L123.1,128z M153.8,92v40.9h5.2h5.2v36v36h-15.7h-15.7V128V51.2h10.4h10.4L153.8,92L153.8,92z M195,92v40.9h4.9h4.9v36v36h-15.4h-15.4v-36v-36h5.2h5.2V92V51.2h5.2h5.2L195,92L195,92z M235.6,128v76.8h-10.1h-10.1v-36v-36h4.9h4.9V92V51.2h5.2h5.2L235.6,128L235.6,128z"/></g></g></g>
</svg>
  );
}

export default IconPiano;